import React, { createContext, ReactNode, useReducer } from 'react';
import { SET_PATIENT_NUMBER } from './constants';

type ListingContextProviderProps = {
  children: ReactNode;
};

type ListingContext = {
  patientNumber: string | null;
  dispatch?: any;
};

type ListingContextState = {
  patientNumber: string | null;
};

const initialState = {
  patientNumber: null,
};

const initListingContext = {
  patientNumber: null,
};

export const ListingContextReducer = (
  state: ListingContextState,
  action: { type: string; payload: mumms.ComponentName | any },
) => {
  let newState = { ...state };
  switch (action.type) {
    case SET_PATIENT_NUMBER:
      newState.patientNumber = action.payload;
      break;
    default:
      newState = state;
      break;
  }
  return newState;
};

export const ListingContext = createContext<ListingContext>(
  initListingContext as ListingContext,
);
export const ListingContextProvider = ({
  children,
}: ListingContextProviderProps) => {
  const [{ patientNumber }, dispatch] = useReducer(
    ListingContextReducer,
    initialState,
  );
  return (
    <ListingContext.Provider
      value={{
        patientNumber,
        dispatch,
      }}
    >
      {children}
    </ListingContext.Provider>
  );
};

export default ListingContextProvider;
